import React, { useRef, useMemo, useState, useEffect } from 'react'
import { Divider, Paper } from '@mui/material';
import { Button } from '@mui/material';
import FormDialog from '../panel/modal';
import JoditEditor from 'jodit-react';
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';

import Swal from 'sweetalert2'
import axios from 'axios';
import api from '../../API/api';
import ViewSchools from '../table/viewSchools';

import Loader from '../panel/loader';
import Affiliation from './addAffiliation';



const AddSchool = () => {

    const [schoolOverview, setSchoolOverview] = useState();
    const [principalMsg, setPrincipalMsg] = useState();
    const [formdata, setFormdata] = useState({
        id: '',
        schoolName: '',
        principalName: '',
        principalDesig: ''
    })

    const [icon, setIcon] = useState();
    const [banner, setBanner] = useState();
    const [principalImg, setPrincipalImg] = useState();

    const [load, setLoad] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [openAffiliation, setOpenAffiliation] = React.useState(false);


    const [schools, setSchools] = useState();
    useEffect(() => {
        getSchools()
    }, []);

    const getSchools = () => {
        setLoad(true)
        api.getSchools().then((res) => {
            setLoad(false)
            setSchools(res.data.schools)
        })
            .catch((err) => {
                // console.log(err.response);
            })

    }

    const handleIcon = (e) => {
        setIcon(e.target.files[0]);
    }

    const handleBanner = (e) => {
        setBanner(e.target.files[0]);
    }

    const handleClickOpen = (data) => {
        setOpen(true);
        if (data) {
            // console.log("==>", data.schoolOverview);
            setFormdata(data);
            setSchoolOverview(data.schoolOverview)
            setPrincipalMsg(data.principalMsg)
        }
    };
    const handleClose = () => {
        setOpen(false);
    };

    // const handleModelAffiliation=()=>{
    //     
    // }

    const handleSchooloverview = (e) => {
        setSchoolOverview(e)
    }
    const handlePrincipalMsg = (e) => {
        setPrincipalMsg(e)
    }
    const handlePrincipalImg = (e) => {
        setPrincipalImg(e.target.files[0])
    }

    const handleForm = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        })
    }

    const submitData = () => {
        setLoad(true)

        if (formdata.schoolName == null || formdata.schoolName == undefined ) {
            Swal.fire({
                title: 'Error!',
                text: 'School Name Cannot be empty !',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            setLoad(false)
            return;
        }
        // console.log(formdata.schoolName ,'formdata.schoolName');
        // return;
        const postData = new FormData();
        postData.append('id', formdata.id);
        postData.append('schoolName', formdata.schoolName);
        postData.append('principalName', formdata.principalName);
        postData.append('principalImg', principalImg);
        postData.append('principalDesig', formdata.principalDesig);
        postData.append('schoolOverview', schoolOverview);
        postData.append('principalMsg', principalMsg);
        postData.append('icon', icon);
        postData.append('banner', banner);

        axios.post(`${process.env.REACT_APP_MAIN_API}saveSchool`, postData)
            .then((res) => {
                // console.log(res);
                setLoad(false)

                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })
                window.location.reload(false);
            })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    // jodit editor
    const editor = useRef(null);

    const config = {
        uploader: {
            insertImageAsBase64URI: true
        },
        height: 420,
        triggerChangeEvent: true,
        readonly: false,
    }


    const SchoolDetails = () => {
        return useMemo(() => (
            <JoditEditor
                // ref={editor}
                config={config}
                value={schoolOverview}
                onChange={handleSchooloverview}
            />
        ), [step, open])
    }

    const PrincipalMessage = () => {
        return useMemo(() => (
            <JoditEditor
                // ref={editor}
                config={config}
                value={principalMsg}
                onChange={handlePrincipalMsg}
            />
        ), [step])
    }


    const [step, setStep] = useState(1);

    const nextStep = () => {
        switch (step) {
            case 1:
                return (
                    <>
                        {form1()}
                    </>
                )

            case 2:
                return (
                    <>
                        {form2()}
                    </>
                )
            case 3:
                return (
                    <>
                        {form2()}
                    </>
                )
            default:
                { form1() };
                break;
        }

    }

    const stepper = () => {
        return (
            <>
                <Paper>
                    <Divider sx={{ borderBottomWidth: '1px', borderBottomColor: 'black' }} />
                    <div className='row justify-content-center p-2'>

                        <Fab color={step === 1 ? 'secondary' : ''} variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>1. School Information </small></div>
                            </div>
                        </Fab>
                        <Fab color={step === 2 ? 'secondary' : ''} variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>2. Principal Information </small></div>
                            </div>
                        </Fab>
                    </div>
                    <Divider sx={{ borderBottomWidth: '5px', borderBottomColor: 'black' }} />
                </Paper>
            </>
        )
    }

    const form1 = () => {
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">
                            <div className="col-md-12 form-group p-2 mandate">
                                <label > <b> School Name </b></label>
                                <input type="text" className="form-control" id="" name='schoolName' value={formdata.schoolName} onChange={handleForm} placeholder="Enter School Name" />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="">Icon</label>
                                <input type="file" className="form-control" id="" name='icon' onChange={handleIcon} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="">Banner</label>
                                <input type="file" className="form-control" id="" name='banner' onChange={handleBanner} />
                            </div>
                            <div className="col-md-12 form-group p-2">
                                <label > <b> School Overview </b></label>
                                {SchoolDetails()}
                            </div>
                        </div>

                        <div className='d-flex justify-content-between'>
                            <div>

                            </div>
                            <div>
                                <Button variant='contained' onClick={() => setStep(2)}>Next</Button>
                            </div>
                        </div>

                    </div>
                </Paper>
            </>
        )
    }

    const form2 = () => {
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">

                            <div className="col-md-12 form-group p-2">
                                <label for="">Principal Name</label>
                                <input type="text" className="form-control" id="" name='principalName' value={formdata.principalName} onChange={handleForm} placeholder="Enter Principal Name" />
                            </div>

                            <div className="col-md-12 form-group p-2">
                                <label for="">Principal Designation</label>
                                <input type="text" className="form-control" id="" name='principalDesig' value={formdata.principalDesig} onChange={handleForm} placeholder="" />
                            </div>

                            <div className="col-md-12">
                                <label htmlFor="">Principal Image</label>
                                <input type="file" className="form-control" id="" name='principalImg' onChange={handlePrincipalImg} />
                            </div>

                            <div className="col-md-12 form-group p-2">
                                <label for=""> <b> Message From The Desk Of Principal </b></label>
                                {PrincipalMessage()}
                            </div>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <div>

                                <Button variant='contained' color='secondary' onClick={() => setStep(1)}>Previous</Button>
                            </div>
                            <div>
                                <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Save <SaveIcon fontSize='small' /></Button>
                            </div>
                        </div>
                    </div>
                </Paper>
            </>
        )
    }



    const form = () => {
        return (
            <>
                {stepper()}
                {nextStep()}
            </>
        )
    }


    return (
        <>
            <div className="row">
                <Paper>
                    <div className="col-12  p-2">

                        <Button variant='contained' className='float-end m-2' onClick={handleClickOpen}>+Add School</Button>
                        <Button variant='contained' className='float-end m-2' onClick={() => setOpenAffiliation(true)}>+Add Affiliation</Button>
                    </div>
                    <FormDialog form={form()} title='Add School' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />

                    <FormDialog size='md' form={<Affiliation handleClose={() => setOpenAffiliation(false)} />} title='Add Affiliation' open={openAffiliation} handleClickOpen={() => setOpenAffiliation(true)} handleClose={() => setOpenAffiliation(false)} />
                </Paper>
                {load && <Loader />}

                <Paper>
                    <div className="col-12">
                        <ViewSchools schools={schools} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default AddSchool;